import FilledButton from "../../../component/FilledButton";
import { Form } from "antd";
import { useEffect,useContext, useState } from "react";
import { ContextState } from '../../../layout'
import { useLocation } from 'react-router-dom';

const SearchPop = ({ categoryData, setcategoryData, setModalOpen, filteredPosts, setSearch,history, loading, setSrLodding }) => {
    const [form] = Form.useForm();
    const { contextReducer } = useContext(ContextState);
    const [value, setValue] = useState()
    const location = useLocation();
    const { pathname  } = location;

    useEffect(() => {
        form.resetFields();
    }, [filteredPosts])

    useEffect(()=>{
        if((contextReducer.cms_type === 'skill-up' || contextReducer.cms_type === 'certificates' || contextReducer.cms_type === 'pre-college') && pathname === "/users"){
            if(value?.title){
                setSrLodding(true)
            }
        }
    },[value])

    return (
        <div className="modal_body">
            <Form
                form={form}
                name="register"
                onFinish={(e) => { setcategoryData(e, form);setModalOpen(false);  setValue(e) }}
                onReset={() => { setModalOpen(false) }}
                initialValues={categoryData}
                className="attached_courses-add_skill search_modal"
            >
               {contextReducer.cms_type === 'skill-up' || contextReducer.cms_type === 'certificates' || contextReducer.cms_type === 'dl-program' || contextReducer.cms_type === 'pre-college' || contextReducer.cms_type === 'career-launch' ? history?.location?.pathname  ==="/contributors" ? <h2>Search Contributor</h2> : <h2>Search User</h2>  :<h2>Search Contributor</h2> } 
                <Form.Item name="title" className="form_group">
                    <input name="name" type="text" className="form_control" autoComplete='off' autoFocus />
                </Form.Item>
                <div className="form_group form_footer">
                    <FilledButton type="reset" className="btn btn_gray" value="Cancel" />
                    <FilledButton type="submit" loading={loading} className="btn btn_primary" value="Search" />
                    
                </div>
            </Form>
        </div>
    )
};

export default SearchPop;